import { z } from 'zod';
import { nullableDefaultObject } from '..';
import { packSchema, packTierSchema } from '../types/packs';

const partialPackTierSchema = nullableDefaultObject(packTierSchema);

export const packTierFormSchema = partialPackTierSchema
    .pick({
        name: true,
        color: true,
        placement: true,
    })
    .extend({
        list: z.enum(['classic', 'platformer']),
    });

export type packTierFormInput = z.input<typeof packTierFormSchema>;

const partialPackSchema = nullableDefaultObject(packSchema);

export const packFormSchema = partialPackSchema
    .pick({
        name: true,
        levels: true,
    })
    .extend({
        list: z.enum(['classic', 'platformer']),
        tier: z.uuidv4(),
    })
    .transform(({ list, levels, ...data }) => ({
        list,
        pack: data,
        levels: levels?.map((level) => level.id),
    }));

export type packFormInput = z.input<typeof packFormSchema>;

export const createPackTierFormSchema = z.object({
    tier: packTierFormSchema,
    pack: partialPackSchema
        .pick({
            name: true,
            levels: true,
        })
        .transform(({ levels, name }) => ({
            name,
            levels: levels?.map((level) => level.id) || [],
        })),
});

export type createPackTierFormInput = z.input<typeof createPackTierFormSchema>;
